// Source-of-truth for the legal terms a new user accepts at signup.
//
// CURRENT_TERMS_VERSION is stamped onto users.terms_version by the signup API
// (src/app/api/auth/signup/route.ts) so we have a per-user audit trail of who
// agreed to which version and when. Bump it (to a new ISO date) whenever the
// hosted Terms of Use materially change, so future acceptances record the new
// version. Keep the format as a plain YYYY-MM-DD date string.
export const CURRENT_TERMS_VERSION = "2026-07-22";

export const TERMS_URL = "https://mucka.ai/terms-of-use/";
export const PRIVACY_URL = "https://mucka.ai/privacy/";
